import { render, staticRenderFns } from "./userCaseDetail.vue?vue&type=template&id=5970153c&scoped=true&"
import script from "./userCaseDetail.vue?vue&type=script&lang=js&"
export * from "./userCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./userCaseDetail.vue?vue&type=style&index=0&id=5970153c&rel=stylesheet%2Fscss&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970153c",
  null
  
)

export default component.exports